import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import PublishersList from "./PublishersList";
import PublisherEdit from "./PublisherEdit";
import PublisherDetailPage from "./PublisherDetailPage";
import { RouteGuard } from "../../guards/RouteGuard";
import { PUBLISHER_WRITE_ROLES, PV_READ_ROLES } from "../../types/roleSets";
function Publishers() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: PV_READ_ROLES },
                React.createElement(PublishersList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: PV_READ_ROLES },
                React.createElement(PublisherDetailPage, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: PUBLISHER_WRITE_ROLES },
                React.createElement(PublisherEdit, null))); } })));
}
export default Publishers;
